import title from "global/constants/TitleConstants";
import { useTitle } from "utils/UseTitle";
import { useState } from "react";
import { Box } from "@mui/material";
import SettingsLayout from "../components/SettingsLayout";
import Passkeys from "./Passkeys";
import MFA from "./MFA";
import Sessions from "./Sessions";
import ChangePassword from "./ChangePassword";
import securityStyles from "./Security.styles";

const styles = securityStyles;

const Security = () => {
  useTitle(title.SECURITY);
  // Each card loads independently so one request never blanks another's card.
  const [mfaLoader, setMfaLoader] = useState<boolean>(false);
  const [passkeyLoader, setPasskeyLoader] = useState<boolean>(false);
  const [openAddPasskeyDialog, setOpenAddPasskeyDialog] =
    useState<boolean>(false);

  return (
    <SettingsLayout activeTab="Security" title="Security">
      {/*
        On the tablet the reference sets Change Password beside a rail carrying
        MFA and Passkeys; `columns` is a single column on the phone and on the
        desktop, so both keep the plain stack they already had.
      */}
      <Box sx={styles.columns}>
        <ChangePassword />

        <Box sx={styles.sideColumn}>
          <MFA loader={mfaLoader} setLoader={setMfaLoader} />

          <Passkeys
            loader={passkeyLoader}
            setLoader={setPasskeyLoader}
            openAddPasskeyDialog={openAddPasskeyDialog}
            setOpenAddPasskeyDialog={setOpenAddPasskeyDialog}
          />
        </Box>
      </Box>

      {/* Four fixed columns wide — it stays full width at every size. */}
      <Sessions />
    </SettingsLayout>
  );
};

export default Security;
